<template>
  <div class="xcx-message-container">
    <!-- 搜索区域 -->
    <div class="search-box">
      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item label="通知门店">
          <el-select v-model="searchForm.storeId" multiple placeholder="请选择门店" style="width: 100%">
            <el-option
                v-for="item in storeList"
                :key="item.id"
                :label="item.storename"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类型">
          <el-select v-model="searchForm.type" placeholder="请选择类型" clearable>
            <el-option label="指定门店" :value="0"></el-option>
            <el-option label="全部门店" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="searchForm.status" placeholder="请选择状态" clearable>
            <el-option label="失效" :value="0"></el-option>
            <el-option label="有效" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
          <el-button type="success" @click="handleAdd">新增</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 表格区域 -->
    <div class="table-box">
      <el-table :data="tableData" border stripe v-loading="loading" style="width: 100%">
        <el-table-column prop="id" label="ID" width="80" align="center"></el-table-column>
        <el-table-column prop="content" label="更新内容" min-width="200" show-overflow-tooltip></el-table-column>
        <el-table-column prop="storeName" label="通知门店" min-width="150" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.type === 1 ? '全部门店' : (scope.row.storeName || '-') }}
          </template>
        </el-table-column>
        <el-table-column prop="type" label="类型" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.type === 1 ? 'success' : 'primary'">
              {{ scope.row.type === 1 ? '全部门店' : '指定门店' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="80" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'">
              {{ scope.row.status === 1 ? '有效' : '失效' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="有效时间"  align="center">
          <template slot-scope="{row}">
            <span v-if="row.startTime">{{row.startTime}} ~ {{row.endTime}}</span>
            <span v-else>永久有效</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="text" size="small" style="color: #F56C6C" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页区域 -->
    <div class="pagination-box">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pagination.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total">
      </el-pagination>
    </div>

    <!-- 新增/编辑弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px" @close="handleDialogClose">
      <el-form :model="form" :rules="rules" ref="formRef" label-width="100px">
        <el-form-item label="更新内容" prop="content">
          <el-input v-model="form.content" type="textarea" :rows="4" placeholder="请输入更新内容"></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-radio-group v-model="form.type" @change="handleTypeChange">
            <el-radio :label="0">指定门店</el-radio>
            <el-radio :label="1">全部门店</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="通知门店" prop="storeId" v-if="form.type === 0">
          <el-select v-model="form.storeIds" multiple placeholder="请选择门店" style="width: 100%">
            <el-option
              v-for="item in storeList"
              :key="item.id"
              :label="item.storename"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="有效时间" prop="startDate">
          <el-date-picker
              v-model="validDate"
              type="daterange"
              value-format="yyyy-MM-dd"
              clearable
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitLoading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'XcxMessage',
  data() {
    // 自定义验证：结束时间必须大于开始时间
    const validateEndTime = (rule, value, callback) => {
      if (value && this.form.startTime) {
        if (new Date(value) <= new Date(this.form.startTime)) {
          callback(new Error('结束时间必须大于开始时间'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    // 自定义验证：指定门店时门店必填
    const validateStoreId = (rule, value, callback) => {
      if (this.form.type === 0 && (!this.form.storeIds || this.form.storeIds.length === 0)) {
        callback(new Error('请选择通知门店'))
      } else {
        callback()
      }
    }
    return {
      validDate: [],
      // 搜索表单
      searchForm: {
        storeId: null,
        type: null,
        status: null
      },
      // 表格数据
      tableData: [],
      loading: false,
      // 分页
      pagination: {
        page: 1,
        limit: 10,
        total: 0
      },
      // 弹窗
      dialogVisible: false,
      dialogTitle: '新增消息',
      isEdit: false,
      submitLoading: false,
      // 表单
      form: {
        id: null,
        content: '',
        type: 0,
        storeId: '',
        storeIds: [],
        startTime: '',
        endTime: ''
      },
      // 门店列表
      storeList: [],
      // 表单验证规则
      rules: {
        content: [
          { required: true, message: '请输入更新内容', trigger: 'blur' },
          { maxLength: 255, message: '更新内容最多255个字符', trigger: 'blur' }
        ],
        storeId: [
          { validator: validateStoreId, trigger: 'change' }
        ]
      }
    }
  },
  created() {
    this.getList()
    this.getStoreList()
  },
  methods: {

    // 获取列表数据
    async getList() {
      this.loading = true
      try {
        const params = {
          page: this.pagination.page,
          limit: this.pagination.limit,
          ...this.searchForm
        }
        // 移除空值参数
        Object.keys(params).forEach(key => {
          if (params[key] === '' || params[key] === null || params[key] === undefined) {
            delete params[key]
          }
        })
        const res = await this.$http.get('/xcxMessage/list', { params })
        if (res.data.status === 0) {
          this.tableData = res.data.data.list || []
          this.pagination.total = res.data.data.total || 0
        } else {
          this.$message.error(res.data.msg || '获取列表失败')
        }
      } catch (error) {
        console.error('获取列表失败:', error)
        this.$message.error('获取列表失败')
      } finally {
        this.loading = false
      }
    },
    // 获取门店列表
    async getStoreList() {
      const { data: res } = await this.$http.get("store/");
      if (res.status == 0) {
        this.storeList = res.data;
      }
    },
    // 搜索
    handleSearch() {
      this.pagination.page = 1
      this.getList()
    },
    // 重置
    handleReset() {
      this.searchForm = {
        content: '',
        type: null,
        status: null
      }
      this.pagination.page = 1
      this.getList()
    },
    // 新增
    handleAdd() {
      this.isEdit = false
      this.dialogTitle = '新增消息'
      this.form = {
        id: null,
        content: '',
        type: 0,
        storeId: '',
        storeIds: [],
        startTime: '',
        endTime: ''
      }
      this.validDate = []
      this.dialogVisible = true
    },
    // 编辑
    handleEdit(row) {
      this.isEdit = true
      this.dialogTitle = '编辑消息'
      this.form = {
        id: row.id,
        content: row.content,
        type: row.type,
        storeId: row.storeId || '',
        storeIds: row.storeId ? row.storeId.split(',').map(id => parseInt(id)) : [],
        startTime: row.startTime,
        endTime: row.endTime
      }
      if (row.startTime) {
        this.validDate = [new Date(row.startTime), new Date(row.endTime)]
      }
      this.dialogVisible = true
    },
    // 删除
    handleDelete(row) {
      this.$confirm('确定要删除该消息吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const res = await this.$http.get(`/xcxMessage/delete/${row.id}`)
          if (res.data.status === 0) {
            this.$message.success('删除成功')
            this.getList()
          } else {
            this.$message.error(res.data.msg || '删除失败')
          }
        } catch (error) {
          console.error('删除失败:', error)
          this.$message.error('删除失败')
        }
      }).catch(() => {})
    },
    // 类型改变
    handleTypeChange(val) {
      if (val === 1) {
        this.form.storeIds = []
        this.form.storeId = ''
      }
    },
    // 提交表单
    handleSubmit() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return

        if(this.validDate && this.validDate.length > 0) {
          this.form.startTime = this.validDate[0]
          this.form.endTime = this.validDate[1]
        }

        this.submitLoading = true
        try {
          // 处理门店ID
          const submitData = {
            ...this.form,
            storeId: this.form.type === 0 ? this.form.storeIds.join(',') : ''
          }
          delete submitData.storeIds

          const url = this.isEdit ? '/xcxMessage/update' : '/xcxMessage/add'
          const res = await this.$http.post(url, submitData)

          if (res.data.status === 0) {
            this.$message.success(this.isEdit ? '更新成功' : '添加成功')
            this.dialogVisible = false
            this.getList()
          } else {
            this.$message.error(res.data.msg || (this.isEdit ? '更新失败' : '添加失败'))
          }
        } catch (error) {
          console.error('提交失败:', error)
          this.$message.error('提交失败')
        } finally {
          this.submitLoading = false
        }
      })
    },
    // 弹窗关闭
    handleDialogClose() {
      this.$refs.formRef && this.$refs.formRef.resetFields()
    },
    // 每页条数改变
    handleSizeChange(val) {
      this.pagination.limit = val
      this.pagination.page = 1
      this.getList()
    },
    // 页码改变
    handleCurrentChange(val) {
      this.pagination.page = val
      this.getList()
    }
  }
}
</script>

<style scoped>
.xcx-message-container {
  padding: 20px;
}
.search-box {
  background: #fff;
  padding: 20px 20px 0;
  margin-bottom: 20px;
  border-radius: 4px;
}
.table-box {
  background: #fff;
  padding: 20px;
  border-radius: 4px;
}
.pagination-box {
  background: #fff;
  padding: 20px;
  margin-top: 20px;
  border-radius: 4px;
  text-align: right;
}
</style>
